import { motion } from "framer-motion";
import { useEffect, useState } from "react";
const LoadingLogo = () => {
  const [animationState, setAnimationState] = useState("schemeA");

  useEffect(() => {
    // Cycle the animation state every 1 second
    const intervalId = setInterval(() => {
      setAnimationState((prevState) =>
        prevState === "schemeA" ? "schemeB" : "schemeA"
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Define variants for the elements that were previously 'front'
  const frontVariants = {
    schemeA: { fill: "#99c9ff" }, // Light Blue
    schemeB: { fill: "#1e7ce4" }, // Dark Blue
  };

  // Define variants for the elements that were previously 'back'
  const backVariants = {
    schemeA: { fill: "#1e7ce4" }, // Dark Blue
    schemeB: { fill: "#99c9ff" }, // Light Blue
  };

  const transition = {
    duration: 0.5,
    type: "spring",
    stiffness: 100,
    damping: 15,
  };

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="250"
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height="250"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        {/* The clipPath IDs remain here, defining the clipping regions */}
        <clipPath id="3aa495f89c">
          <path
            d="M 102.980469 116 L 230 116 L 230 297.960938 L 102.980469 297.960938 Z M 102.980469 116 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1fa359fbeb">
          <path
            d="M 139 55.710938 L 205 55.710938 L 205 111 L 139 111 Z M 139 55.710938 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>

      {/* Group that uses the first clipPath ID */}
      <motion.g clipPath="url(#3aa495f89c)">
        {/* 1. FRONT element (originally inside the first group) */}
        <motion.path
          variants={frontVariants}
          animate={animationState}
          transition={transition}
          d="M 109.835938 294.355469 C 106.226562 286.683594 103.730469 277.078125 103.148438 268.632812 C 101.578125 245.847656 111.664062 228.347656 129.742188 222.484375 C 163.800781 218.207031 135.296875 222.425781 122.578125 201.554688 C 115.175781 187.152344 117.433594 168.382812 128.589844 151.558594 C 136.40625 139.777344 150.019531 126.742188 159.097656 122.347656 C 160.140625 121.84375 161.796875 121.027344 162.78125 120.53125 C 165.253906 119.289062 170.441406 117.589844 173.742188 116.945312 C 177.398438 116.230469 184.082031 116.230469 187.503906 116.949219 C 191.4375 117.777344 195.621094 119.957031 197.898438 122.367188 C 199.578125 124.140625 199.769531 124.507812 199.769531 125.953125 C 199.769531 127.339844 199.597656 127.710938 198.488281 128.683594 C 197.785156 129.300781 195.878906 130.472656 194.25 131.285156 C 182.246094 137.277344 173.707031 147.265625 170.699219 158.84375 C 168.984375 165.4375 169.085938 174.140625 170.960938 181.304688 C 175.847656 199.957031 193.511719 216.0625 215.28125 221.710938 C 220.46875 223.058594 220.90625 223.066406 222.132812 221.839844 C 223.292969 220.679688 223.460938 219.824219 222.8125 218.394531 C 222.355469 217.398438 221.589844 217.035156 218.167969 216.195312 C 216.878906 215.878906 214.707031 215.289062 213.339844 214.882812 L 210.851562 214.144531 L 212.796875 213.039062 C 213.863281 212.429688 215.765625 210.886719 217.019531 209.613281 L 219.300781 207.292969 L 222.101562 210.136719 C 225.328125 213.40625 227.4375 216.757812 228.871094 220.878906 C 229.789062 223.515625 229.875 224.214844 229.882812 228.996094 C 229.890625 233.582031 229.789062 234.515625 229.050781 236.570312 C 226.21875 244.4375 219.949219 249.65625 212.132812 250.648438 C 207.351562 251.253906 202.90625 250.5 189.851562 246.871094 C 168.054688 240.8125 151.589844 244.003906 139.507812 256.628906 C 135.148438 261.1875 133.355469 263.742188 122.464844 280.9375 C 119.765625 285.203125 116.195312 290.773438 114.539062 293.316406 L 111.519531 297.9375 Z M 109.835938 294.355469 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </motion.g>

      {/* 2. FRONT element (top-level path) */}
      <motion.path
        variants={frontVariants}
        animate={animationState}
        transition={transition}
        d="M 199.632812 208.621094 C 189.21875 202.222656 180.9375 192.355469 177.617188 182.386719 C 175.496094 176.027344 174.917969 168.0625 176.144531 162.082031 C 177.945312 153.285156 183.722656 145.09375 192.015625 139.570312 L 195.261719 137.410156 L 196.886719 138.347656 C 205.148438 143.113281 211.367188 151.878906 214.371094 162.984375 C 217.226562 173.558594 218.449219 191.328125 216.765625 197.730469 C 215.789062 201.433594 214.507812 203.707031 212.15625 205.933594 C 209.746094 208.214844 206.878906 209.554688 203.96875 209.765625 C 201.921875 209.910156 201.59375 209.824219 199.632812 208.621094 Z M 199.632812 208.621094 "
        fillOpacity="1"
        fillRule="nonzero"
      />

      {/* 3. BACK element (top-level path) */}
      <motion.path
        variants={backVariants}
        animate={animationState}
        transition={transition}
        d="M 223.402344 202.53125 C 222.605469 202.292969 221.988281 201.941406 222.03125 201.75 C 222.070312 201.558594 222.394531 200.265625 222.75 198.875 C 223.285156 196.796875 223.398438 194.910156 223.382812 188.234375 C 223.335938 168.6875 219.554688 153.976562 212.011719 144.011719 C 211.03125 142.71875 210.234375 141.441406 210.234375 141.167969 C 210.234375 140.609375 212.492188 137.546875 213.628906 136.5625 C 214.042969 136.207031 215.925781 134.996094 217.808594 133.878906 C 219.691406 132.757812 221.921875 131.378906 222.761719 130.808594 L 224.28125 129.777344 L 225.40625 131.320312 C 227.40625 134.0625 231.1875 140.660156 232.605469 143.882812 C 235.289062 149.980469 237.554688 158.382812 238.769531 166.769531 C 239.398438 171.101562 239.402344 182.144531 238.777344 186.25 C 237.757812 192.910156 235.855469 197.261719 232.699219 200.148438 C 229.855469 202.746094 226.75 203.542969 223.402344 202.53125 Z M 223.402344 202.53125 "
        fillOpacity="1"
        fillRule="nonzero"
      />

      {/* 4. BACK element (top-level path) */}
      <motion.path
        variants={backVariants}
        animate={animationState}
        transition={transition}
        d="M 203.492188 135.488281 L 201.625 134.0625 L 202.847656 132.988281 C 203.519531 132.394531 204.503906 131.027344 205.035156 129.941406 C 205.871094 128.230469 205.976562 127.652344 205.824219 125.546875 C 205.617188 122.65625 204.683594 120.652344 202.417969 118.230469 C 195.367188 110.691406 181.238281 108.207031 167.902344 112.164062 C 166.542969 112.566406 165.367188 112.832031 165.289062 112.75 C 164.964844 112.425781 168.976562 107.074219 171.390625 104.613281 C 179.5 96.347656 189.867188 92.191406 200.988281 92.746094 C 205.832031 92.988281 208.359375 93.617188 212.367188 95.578125 C 217.675781 98.179688 221.71875 103.125 222.796875 108.335938 C 223.445312 111.460938 223.71875 119.691406 223.230469 121.476562 C 222.65625 123.59375 221.503906 124.601562 215.859375 127.921875 C 211.445312 130.519531 207.476562 133.792969 205.878906 136.152344 C 205.363281 136.914062 205.351562 136.910156 203.492188 135.488281 Z M 203.492188 135.488281 "
        fillOpacity="1"
        fillRule="nonzero"
      />

      {/* Group that uses the second clipPath ID */}
      <motion.g clipPath="url(#1fa359fbeb)">
        {/* 5. BACK element (originally inside the second group) */}
        <motion.path
          variants={backVariants}
          animate={animationState}
          transition={transition}
          d="M 144.527344 105.230469 C 142.964844 103.484375 141.140625 100.199219 140.203125 97.453125 C 138.902344 93.644531 138.824219 88.085938 140.003906 83.882812 C 143.214844 72.480469 153.214844 63.109375 167.566406 58.066406 C 174.488281 55.632812 182.792969 55.023438 188.511719 56.53125 C 235.316406 72.449219 165.347656 127.664062 144.527344 105.230469 Z M 144.527344 105.230469 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </motion.g>
    </motion.svg>
  );
};

export default LoadingLogo;
